import moment from "moment";
import { splitHtmlByLimit } from 'utils/bio-limit';
import { DEFAULT_RESUME_BIO_LIMIT } from 'constants/options';
import _ from "lodash";

export const csx = (classes) => classes.filter(Boolean).join(" ");

function generateRandomAlphanumericString(length) {
  const alphanumeric =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = alphanumeric.length;
  let result = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charactersLength);
    result += alphanumeric.charAt(randomIndex);
  }

  return result;
}

export const formatDate = (obj, dateFormat, t) => { 
  let {
    start_month,
    start_day,
    start_year,
    end_month,
    end_day,
    end_year,
    is_start_date_approximately,
    is_end_date_approximately,
    is_present,
  } = obj;
  let getUser_data = localStorage.getItem('user_data');
      getUser_data = JSON.parse(getUser_data); 
  let lang = currentLang() === 'ch' ? 'zh-cn' : (currentLang() || 'en');
  let date = "";
  let formatString;
  let formatStringEnd;
  let isStartYearOnly = false;
  if(getUser_data?.user){
    formatString = !dateFormat ? "MMMM D YYYY" : "D MMMM YYYY";
    formatStringEnd = !dateFormat ? "MMMM D YYYY" : "D MMMM YYYY";
  }else{
    formatString = localStorage.getItem('dateFormat');
    formatStringEnd = localStorage.getItem('dateFormat');
  }

  if (!formatString) formatString = "MMMM D YYYY";
  if (!formatStringEnd) formatStringEnd = "MMMM D YYYY";
  

  if (is_start_date_approximately) {
    if (start_month && start_year) {
      formatString = (start_day ? formatString : "MMMM YYYY");
      date = `${moment() 
        .locale(lang)
        .month(start_month - 1)
        .year(start_year)
        .format(formatString)}  (${t('Approximately')})`;
    } else if (start_year) {
      date = start_year + ` (${t('Approximately')})`;
    }
  } else {
    if (start_day && start_month && start_year) {
      if (
        Intl.DateTimeFormat().resolvedOptions().timeZone ===
          "America/New_York" ||
        Intl.DateTimeFormat().resolvedOptions().timeZone ===
          "America/Los_Angeles"
      ) {
        date = moment([start_year, start_month - 1, start_day]).format(
          formatString
        );
      } else {
        date = moment([start_year, start_month - 1, start_day])
        .locale(lang)
        .format(
          formatString
        );
      }
    } else {
      if (start_month && start_year) {
        formatString = (start_day ? formatString : "MMMM YYYY");
        date = `${moment()
          .locale(lang)
          .month(start_month - 1)
          .year(start_year)
          .format(formatString)}`;
      } else if (start_year) {
        date = start_year;
        isStartYearOnly = true;
      }
    }
  }

  if (
    (start_day || start_month || start_year) &&
    (end_day || end_month || end_year || is_present)
  ) {
    date = date + " — ";
  }

  if (is_present) {
    date = date + t("Present");
  } else {
    if (is_end_date_approximately) {
      if (end_month && end_year) {
        formatString = (end_day ? formatString : "MMMM YYYY");
        date =
          date +
          `${moment()
            .locale(lang)
            .month(end_month - 1)
            .year(end_year)
            .format(formatString)} (${t('Approximately')})`;
      } else if (end_year) {
        date = date + end_year + ` (${t('Approximately')})`;
      }
    } else {
      if (end_day && end_month && end_year) {
        if (
          Intl.DateTimeFormat().resolvedOptions().timeZone ===
            "America/New_York" ||
          Intl.DateTimeFormat().resolvedOptions().timeZone ===
            "America/Los_Angeles"
        ) {
          date =
            date +
            moment([end_year, end_month - 1, end_day]).format(formatStringEnd);
        } else {
          date =
            date +
            moment([end_year, end_month - 1, end_day])
            .locale(lang)
            .format(formatStringEnd);
        }
      } else {
        if (end_month && end_year) {
          formatStringEnd = (end_day ? formatStringEnd : "MMMM YYYY");
          date =
            date +
            `${moment()
              .locale(lang)
              .month(end_month - 1)
              .year(end_year)
              .format(formatStringEnd)}`;
        } else if (end_year) {
          date = date + `${end_year}`;
          if(isStartYearOnly && end_year === start_year){
            return start_year;
          }
        }
      }
    }
  }

  return date;
};



const stat_date = (obj) => {
  return obj.map((milestone) => {
    const {
      start_day,
      start_month,
      start_year,
    } = milestone || {};

    // Helper function to pad numbers to 2 digits
    const pad = (num) => (num ? String(num).padStart(2, '0') : null);

    // Calculate start_date
    const startDate =
      start_year && start_month && start_day
        ? `${start_year}-${pad(start_month)}-${pad(start_day)}`
        : start_year && start_month
        ? `${start_year}-${pad(start_month)}-01`
        : start_year
        ? `${start_year}-12-31`
        : null;

    return {
      ...milestone,
      start_date: startDate,
    };
  });
};

export const sortMilestones = (milestones) => {
  const processed = stat_date(milestones);
  return processed.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
};

export  const compareDate = (obj) => {
  const {start_date=null, end_date=null, start_year, start_month, start_day, end_year, end_month, end_day, is_present} = obj;
  let today = moment();
  let check_start_year;
  let check_end_year;
  const event = ["upcoming","current","past"]
  
  if ((!start_month && !start_day)) {
    check_start_year = moment(start_year, 'YYYY').endOf("year");
    let continueCheck = groupEvent(check_start_year,today, 'year');
    if(event.includes(continueCheck)){
      return continueCheck;
    } 

  }if (!start_day) {
    check_start_year = moment(`${start_year}-${start_month}`, 'YYYY-MM');
    let continueCheck = groupEvent(check_start_year,today, 'month');
    if(event.includes(continueCheck)){
      return continueCheck;
    } 
  }
  if (start_day && start_month && start_year) {
    let check_start_date = start_date ? start_date : `${start_year}-${start_month}-${start_day}`
    check_start_year = moment(check_start_date, 'YYYY-MM-DD');
    let continueCheck = groupEvent(check_start_year,today,'day'); 
    if(event.includes(continueCheck)){
      return continueCheck;
    } 

  }
  if ((!end_month && !end_day)){
    check_end_year = moment(end_year, 'YYYY');
    let continueCheck = groupEvent(check_end_year,today, 'year',is_present, false);
    if(event.includes(continueCheck)){
      return continueCheck;
    } 

  }if(!end_day){
    check_end_year = moment(`${end_year}-${end_month}`, 'YYYY-MM');
    let continueCheck = groupEvent(check_end_year,today, 'month',is_present, false);
    if(event.includes(continueCheck)){
      return continueCheck;
    } 

  } 
   if (end_day && end_month && end_year) {
    let check_end_date = end_date ? end_date : `${end_year}-${end_month}-${end_day}`
    check_end_year = moment(check_end_date, 'YYYY-MM-DD');
    let continueCheck = groupEvent(check_end_year,today,'day',is_present,false);
    if(event.includes(continueCheck)){
      return continueCheck;
    } 

  } else {
    return 'past';
  }
};

const groupEvent = (inputDate,today,dateName,is_present, eventUpcoming=true) =>{ 
 
  try{
    if(eventUpcoming){
      if (inputDate.isAfter(today)) { 
        return 'upcoming'
      }else{
        return true;
      }
    }
    else if(!eventUpcoming){ 
      if (inputDate.isSame(today, dateName) || inputDate.isAfter(today, dateName) || is_present){
        return 'current';
      }else{
        return 'past';
      }
    }else {
      return true;
    }
  }catch(e){
    console.log(`Error: ${e}`)
  }
}

export const removePostalCode = (address) => {
  const postalCodeRegex = /\b\d{4}(?:-\d{4})?\b/;
  const updatedAddress = address.replace(postalCodeRegex, '').trim();
  return updatedAddress;
};

export const urlSerializer = (endpoint, obj) => {
  const params = new URLSearchParams();

  Object.entries(obj).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== "" && item !== "null") {
          params.append(`${key}[]`, item);
        }
      });
    } else if (value !== "" && value !== "null" && value !== undefined && value !== null) {
      params.append(key, value);
    }
  });

  return `${endpoint}?${params.toString()}`;
};

export const listFormat = (arr, lang='en') => {
  if(lang){
    const lf = new Intl.ListFormat(lang || 'en');
    return lf.format(arr);
  }else{
    const lf = new Intl.ListFormat('en');
    return lf.format(arr);
  }
  
};

export const capitalizeWords = (string) => {
  return string.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

/**
 * Title-case a string per the client's rule (Marker.io MCF-1798):
 *  - Capitalise the first letter of every main word.
 *  - Keep the small linking words below lowercase, but only in the middle of
 *    the title; the first word is always capitalised.
 *  - Short verbs (Is, Are, Was, Have, Do…) are NOT in the list, so they stay
 *    capitalised as "main" words.
 * The rest of each word is left untouched so acronyms / intentional casing
 * (EMAF, iPhone, U2) survive.
 */
const TITLE_CASE_LOWERCASE_WORDS = new Set([
  "a", "an", "the", "and", "but", "or", "nor", "for", "so", "yet",
  "as", "at", "by", "in", "of", "on", "to",
]);

export const toTitleCase = (value) => {
  if (!value || typeof value !== "string") return value;
  let seenWord = false;
  return value
    .split(/(\s+)/)
    .map((token) => {
      if (token === "" || /^\s+$/.test(token)) return token;
      const isFirstWord = !seenWord;
      seenWord = true;
      const lower = token.toLowerCase();
      if (!isFirstWord && TITLE_CASE_LOWERCASE_WORDS.has(lower)) return lower;
      return token.charAt(0).toUpperCase() + token.slice(1);
    })
    .join("");
};

export const isImgUrl = (url) => {
  return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
};

export const randomExtension = () => {
  return generateRandomAlphanumericString(4);
};

export const isValidYoutubeVideoLink = (url) => {
  const youtubeVimeoRegex =
    /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/|vimeo\.com\/)([a-zA-Z0-9_-]{11}|[0-9]+)/;

  return youtubeVimeoRegex.test(url);
};

export const removeUndefinedProperties = (obj) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

export const CIVIL_STATUS = [
  { label: "Married", value: "Married" },
  { label: "Widowed", value: "Widowed" },
  { label: "Separated", value: "Separated" },
  { label: "Divorced", value: "Divorced" },
  { label: "Single", value: "Single" },
];

export const CHILD = [
  { label: "0 Children", value: 0 },
  { label: "1 Child", value: 1 },
  { label: "2 Children", value: 2 },
  { label: "3 Children", value: 3 },
  { label: "4 Children", value: 4 },
  { label: "5 Children", value: 5 },
  { label: "6 Children", value: 6 },
  { label: "7 Children", value: 7 },
  { label: "8 Children", value: 8 },
  { label: "9 Children", value: 9 },
  { label: "10 Children", value: 10 },
];

export const HAIR_COLOR = [
  { label: "Black", value: "Black" },
  { label: "Blonde", value: "Blonde" },
  { label: "Brown", value: "Brown" },
  { label: "Dark Brown", value: "Dark Brown" },
  { label: "Red", value: "Red" },
];

export const EYE_COLOR = [
  { label: "Amber ", value: "Amber" },
  { label: "Blue", value: "Blue" },
  { label: "Brown", value: "Brown" },
  { label: "Gray", value: "Gray" },
  { label: "Green", value: "Green" },
  { label: "Hazel", value: "Hazel" },
];

export const resumeLinkId = () => {
  return generateRandomAlphanumericString(8);
};

export async function copyTextToClipboard(text) {
  if ("clipboard" in navigator) {
    return await navigator.clipboard.writeText(text);
  } else {
    return document.execCommand("copy", true, text);
  }
}

export const imageSquareOrPortrait = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    img.onload = () => {
      if (img.width > img.height) {
        if (img.width - img.height > 100) {
          resolve("landscape");
        } else {
          resolve("square");
        }
      } else if (img.width < img.height) {
        resolve("portrait");
      } else {
        resolve("square");
      }
    };
  });
};

export const dateOrder = (current, previous) =>{
  if(_.isEmpty(current) && _.isEmpty(current)){
    return;
  }
  const current_years = current.map(date => date.start_year);
  const minYear = Math.min(...current_years);
  const prev_years = previous.map(date => date.end_year || date.start_year);
  const maxYear = Math.max(...prev_years);
  let dateOrder = {
    Upcoming : _.isEmpty(current) ? 'Upcoming' : `${minYear} to present`,
    Previous : _.isEmpty(previous) ? 'Previous' : `Ordered as ${maxYear}`
  }
  localStorage.setItem("dateOrder", JSON.stringify(dateOrder));

}

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const personalDateFormat = (date, dateFormat)=>{
  return moment(date).format(!dateFormat ? "MMMM D YYYY" : "D MMMM YYYY");
}

export const display_name = (data)=>{  
  let user_data = JSON.parse(localStorage.getItem('user_data'));
  const {user,profile} = user_data;
  console.log("DISPLAY NAME")
  console.log(user_data);
  if((profile?.displayName)){
    switch (profile?.displayName){
      case "First Name":
        return user?.first_name;
      case "Surename":
        return user?.last_name;
      case "Other Name":
        return user?.other_name || profile?.other_name;
      case "Username":
        return user?.username;
      case "First Name Surname":
        return `${user?.first_name} ${user?.last_name}`;
      default:
        return user?.other_name || profile?.other_name;;
    } 
  }else{
    return user?.username;
  }
}

export const profileURL = () =>{
  const extension = randomExtension();
  const userData = localStorage.getItem('user_data');

    let user = null;
    let profile = null;

    if (userData) {
        try {
            const parsedData = JSON.parse(userData);
            user = parsedData.user || null;
            profile = parsedData.profile || null;
        } catch (e) {
            console.error("Error parsing user_data:", e);
        }
    }
    const {origin} = window.location;
    // The public profile route resolves by the PROFILE id (the slug prefix is
    // ignored). Using user.id here pointed the QR at a non-existent profile, so
    // every scan landed on "page cannot be found" (Marker.io MCF-1769).
    let url = `${origin}/${encodeURIComponent(user?.username)}/profile/${profile?.id}`
    return url;
}

export const profileTag = (mention_names,Description)=>{
  let newDesc = Description;
  Object.keys(mention_names).forEach((k) => {
    // const username = mention_names[k]?.username;
    const pName = mention_names[k]?.p_name;
    const pUsername = mention_names[k]?.p_username;
    // Regex to match href containing username and capture the name between <a> and </a>
    // const regex = new RegExp(`(<a[^>]*href="[^"]*${username}[^"]*"[^>]*>)(.*?)(<\/a>)`, 'g');
    const regex = new RegExp(`(<a[^>]*key="[^"]*${pUsername}[^"]*"[^>]*>)(.*?)(<\/a>)`, 'g');
    
      newDesc = newDesc.replace(regex, (match, openingTag, name, closingTag) => {
      return `${openingTag}${pName}${closingTag}`;
    });
  });
  return newDesc;
}


export const sortNoteLatest = (data)=>{
  const sortedData = [...data].map((item)=>{
    // item.start_date = `${item?.start_year}-${item.start_month || 12}-${item?.start_day || (item.start_month === 2 ? 28 : 31)}`
    const hasMonth = !!item?.start_month;
    const hasDay = !!item?.start_day;
    // Determine precision level (1 = full date only, 2 = month-year, 3 = year)
    let precision = 1;
    if (hasMonth && !hasDay) precision = 2;
    if (!hasMonth && !hasDay) precision = 3;
    item._precision = precision;

    const month = item?.start_month || 1;
    const day = item?.start_day || 1;
    item.start_date = `${item?.start_year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    // remove the # to sorth with it
    if (item?.date_note && typeof item.date_note === 'string') {
      const cleaned = item.date_note.startsWith('#') ? item.date_note.slice(1) : item.date_note;
      const num = Number(cleaned);
      item._cleaned_date_note = isNaN(num) ? cleaned : num;
    } else {
      item._cleaned_date_note = item.date_note;
    }
    return item;
  }).sort((a, b) => { 

    let compareDate = new Date(b.start_date) - new Date(a.start_date)
    if (compareDate !== 0) return compareDate;

    // 2. If same date, prioritize lower precision (full > month > year )
    if (a._precision !== b._precision) return a._precision - b._precision;

    // Sort by cleaned date_note
    const aNote = a._cleaned_date_note;
    const bNote = b._cleaned_date_note;
    
    if (aNote === null && bNote === null) return 0;
    if (aNote === null) return 1;
    if (bNote === null) return -1;

    if (typeof aNote === 'number' && typeof bNote === 'number') {
      return aNote - bNote;
    }

    return String(aNote).localeCompare(String(bNote));
    // return compareDate;
  })

  return sortedData;
} 

export const sortOldest = (data)=>{
  const sortedData = [...data].map((item)=>{
    const hasMonth = !!item?.start_month;
    const hasDay = !!item?.start_day;
    // Determine precision level (1 = year only, 2 = month-year, 3 = full date)
    let precision = 1;
    if (hasMonth && !hasDay) precision = 2;
    if (hasMonth && hasDay) precision = 3;
    item._precision = precision;

    const month = item?.start_month || 1;
    const day = item?.start_day || 1;
    item.start_date = `${item?.start_year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    // remove the # to sorth with it
    if (item?.date_note && typeof item.date_note === 'string') {
      const cleaned = item.date_note.startsWith('#') ? item.date_note.slice(1) : item.date_note;
      const num = Number(cleaned);
      item._cleaned_date_note = isNaN(num) ? cleaned : num;
    } else {
      item._cleaned_date_note = item.date_note;
    }
    return item;
  }).sort((a, b) => {
    let compareDate = new Date(a.start_date) - new Date(b.start_date)
    if (compareDate !== 0) return compareDate;
    
    // 2. If same date, prioritize lower precision (year > month > full)
    if (a._precision !== b._precision) return a._precision - b._precision;

     // Sort by cleaned date_note
    const aNote = a._cleaned_date_note;
    const bNote = b._cleaned_date_note;
    
    if (aNote === null && bNote === null) return 0;
    if (aNote === null) return 1;
    if (bNote === null) return -1;

    if (typeof aNote === 'number' && typeof bNote === 'number') {
      return aNote - bNote;
    }

    return String(aNote).localeCompare(String(bNote));
    // return compareDate;
  })

  return sortedData;
}

export function isValidURL(url) {
  const urlRegex = /^(https?:\/\/)([\w.-]+)(:\d+)?(\/[^\s]*)?$/i;
  return urlRegex.test(url);
}

export function generateNDigitID(length = 4) {
  if (length < 1) throw new Error("Length must be at least 1");

  const min = 1; // Minimum value
  const max = Math.pow(10, length) - 1; // Maximum value for the given length

  const num = Math.floor(min + Math.random() * (max - min + 1));

  // Pad the number to ensure it matches the desired length
  return num.toString().padStart(length, '0');
}

export const currentLang = ()=>{
    const lang = localStorage.getItem('lang') ?? null;
    return lang;
}


export const cleanQuillContent = (html) => { // remove last br
  return html.replace(/(<p><br><\/p>\s*)+$/, "");
};

/**
 * Parse a date-only value (e.g. a birthdate "YYYY-MM-DD" from the API) into a
 * LOCAL Date at midnight. Plain `new Date("YYYY-MM-DD")` parses as UTC, which
 * renders the previous calendar day for viewers in negative-UTC timezones
 * (the birthdate off-by-one bug). Accepts a Date (returned as-is) or a string;
 * only the leading Y-M-D is used, so a full datetime is handled too.
 */
export const parseDateOnly = (value) => {
  if (!value) return null;
  // Date-only values (e.g. birthdate) are normalised to LOCAL NOON so a later
  // UTC conversion (toISOString / UTC formatting in the resume preview) can't
  // roll them back to the previous day in positive-UTC timezones — e.g. a DOB
  // picked as the 15th was showing as the 14th in AEDT. (Marker.io birthdate off-by-one)
  if (value instanceof Date) {
    return isNaN(value.getTime())
      ? null
      : new Date(value.getFullYear(), value.getMonth(), value.getDate(), 12, 0, 0);
  }
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) {
    const fallback = new Date(value);
    return isNaN(fallback.getTime())
      ? null
      : new Date(fallback.getFullYear(), fallback.getMonth(), fallback.getDate(), 12, 0, 0);
  }
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12, 0, 0);
};

export const get_age = (bday = new Date()) => {
  const birthDate = parseDateOnly(bday) || new Date(bday);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
};

export const removeDuplicateID = (newSet)=>{
			const seenIds = new Set();
			const uniqueArray = newSet.filter(item => {
				// Check if the id has already been seen
				const isDuplicate = seenIds.has(item.id);
				// If not a duplicate, add it to the Set and keep the item
				if (!isDuplicate) {
					seenIds.add(item.id);
					return true;
				}
				return false; // Filter out the duplicate
			});
      return uniqueArray
}

export const dataURLtoFile = (dataURL, filename) => {
  const arr = dataURL.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};


export const cleanHtml = (html) => {
  return html
    .replace(/<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '') // remove empty <p>
    .replace(/<a\b[^>]*>(\s|&nbsp;|<br\s*\/?>)*<\/a>/gi, '') // remove empty <a> (even with href)
    .trim();
};
/**
 * Keep only the part of a bio that fits inside `limit`.
 *
 * Delegates to utils/bio-limit so the editor, the live preview and the PDF
 * cannot disagree about where the cut falls. Counts grapheme clusters, so an
 * emoji at the boundary is never split in half.
 */
export function truncateHtmlByVisibleLength(html = '', limit) {
  // Deprecated: prefer truncateBioForTemplate(html, templateName), which reads the
  // limit from config. This used to default to 215; with the default gone, an
  // omitted limit would read as zero and silently truncate the bio to nothing, so
  // fall back to the configured default and say so rather than deleting the text.
  if (typeof limit !== 'number') {
    console.warn(
      'truncateHtmlByVisibleLength called without a limit; falling back to ' +
        DEFAULT_RESUME_BIO_LIMIT +
        '. Pass the limit from config, or use truncateBioForTemplate.'
    );
    return splitHtmlByLimit(html, DEFAULT_RESUME_BIO_LIMIT).keptHtml;
  }
  return splitHtmlByLimit(html, limit).keptHtml;
}